import { api } from '../config/api'

const baseEndpoint = '/EvaluationMethodApi'

export const getAllEvaluationMethods = () => api.get(`${baseEndpoint}/GetAll`)
